import { render, staticRenderFns } from "./infoSetting.vue?vue&type=template&id=10e04c29"
import script from "./infoSetting.vue?vue&type=script&lang=js"
export * from "./infoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports